import React from "react";
import { useNavigate } from "react-router-dom";
import { APP_ORIGIN, appUrl } from "../../lib/appBase";
import { TOOL_COUNT } from "../../lib/toolMeta";
import { TOOL_PATHS } from "../../lib/slugs";
import homeStyle from "../../style/home.module.less";
import { ToolExplorer } from "./ToolExplorer";
import { EvmFeature } from "./EvmFeature";
import { HeroArt } from "./HeroArt";
import { Marquee } from "./Marquee";
import { RentCheck } from "../common/RentCheck";
import {
  HowItWorks,
  WhySolstack,
  Faq,
  FinalCta,
} from "./sections";

export const Home = () => {
  const navigate = useNavigate();

  return (
    <div className={homeStyle.wrap}>
      <div className={homeStyle.page}>
        <section className={homeStyle.hero}>
          <div className={homeStyle.heroFx} aria-hidden="true">
            <span className={homeStyle.fxGrid} />
          </div>

          <div className={homeStyle.heroInner}>
            <div className={homeStyle.heroCopy}>
              <span className={homeStyle.heroEyebrow}>
                <span className={homeStyle.heroEyebrowDot} />
                Solana token toolkit
              </span>
              <h1 className={homeStyle.heroTitle}>
                Everything you need to{" "}
                <span className={homeStyle.heroTitleGrad}>ship a token</span>{" "}
                on Solana.
              </h1>
              <p className={homeStyle.heroSub}>
                Create, distribute, manage and audit Solana tokens from your wallet.
                Your keys never leave it. Fees shown before you sign.
              </p>
              {/* The one tool people arrive wanting most: see the SOL locked
                  in a wallet before connecting anything, then reclaim it. */}
              <RentCheck
                className={homeStyle.heroCheck}
                reclaimLink={(address, label) => (
                  <a className="rc-link" href={`${appUrl("rent-reclaim")}?address=${encodeURIComponent(address)}`} rel="nofollow">
                    {label}
                  </a>
                )}
              />
              <div className={homeStyle.heroActions}>
                <a href={APP_ORIGIN} rel="nofollow" className={homeStyle.ctaPrimary}>
                  Enter Solstack <span className={homeStyle.ctaArrow}>→</span>
                </a>
                <a className={homeStyle.ctaGhost} href="/docs/overview">
                  Docs
                </a>
              </div>
              {/* The tools people come for most, linked to their landing
                  pages (the pages written to rank for them) rather than
                  straight into the app: the home page is the site's
                  strongest page, and these are its strongest links. */}
              <div className={homeStyle.heroQuick}>
                <a href={`/tools/${TOOL_PATHS["rent-reclaim"]}`}>Reclaim rent</a>
                <a href={`/tools/${TOOL_PATHS.multisender}`}>Multisender</a>
                <a href={`/tools/${TOOL_PATHS.airdrop}`}>Airdrop tool</a>
                <a href={`/tools/${TOOL_PATHS["create-spl"]}`}>Solana token creator</a>
              </div>
            </div>

            <div className={homeStyle.heroArt} aria-hidden="true">
              <HeroArt className={homeStyle.heroArtImg} />
            </div>

            {/* Under the art on wide screens, so both columns end level;
                after the copy on phones (grid areas in home.module.less). */}
            <div className={homeStyle.heroStats}>
              <span>
                <b>{TOOL_COUNT}</b>on-chain tools
              </span>
              <span>
                <b>Upfront</b>itemized fees
              </span>
              <span>
                <b>Your keys</b>stay in your wallet
              </span>
            </div>
          </div>

        </section>

        <Marquee />

        <EvmFeature />
        <ToolExplorer />
        <HowItWorks />
        <WhySolstack />
        <Faq />
        <FinalCta
          onOpen={() =>
            APP_ORIGIN.startsWith("http") ? (window.location.href = APP_ORIGIN) : navigate(APP_ORIGIN)
          }
        />
      </div>
    </div>
  );
};
